export enum SourceCodeStorageLocation {
	CLIENT_RESPONSIBILITY = "CLIENT_RESPONSIBILITY",
	BUSINESSUNIT_RESPONSIBILITY = "BUSINESSUNIT_RESPONSIBILITY",
	NO_SOURCE_CODE = "NO_SOURCE_CODE",
}
